import { combineReducers } from "redux";

const initialState = {
  major: "",
};

export const types = {
  SELECT_MAJOR: "MAJOR_QUERY/SELECT_MAJOR",
};

export const actions = {
  //专业查询将选择的专业保存到redux
  cacheMajor: (major) => {
    return {
      type: types.SELECT_MAJOR,
      major,
    };
  },
};

//专业查询选择专业的reducer
const majorData = (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_MAJOR:
      return { ...state, major: action.major };
    default:
      return { ...state };
  }
};

const reducer = combineReducers({
  majorData,
});

export default reducer;



// WEBPACK FOOTER //
// ./src/redux/modules/majorquery.js